import { Required, Schema, TextField } from "lego-gui-lib/lib";
import { t } from "../../../core/i18n/i18n";
import { mainStore, api } from "../../../core/mainStore";
import { NetworkOperatorFK } from "../schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { Auth } from "../../../core/model/auth";

export const NetworkOperatorPrefixSchema = new Schema({
  fields: [
    {
      name: "netOperatorRef",
      title: t("hns:networkOperator:domain"),
      type: NetworkOperatorFK,
      readonly: true
    },
    {
      name: "prefix",
      title: t("common:prefix"),
      type: TextField(Required)
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  }
});

export const NetworkOperatorPrefixSchemaColumns = NetworkOperatorPrefixSchema.extend(
  {
    netOperatorRef: false
  }
);

mainStore.networkOperatorPrefix = RemoteChildDataSource.create({
  parent: mainStore.networkOperator.oneDataSource,
  api: api,
  name: "networkOperatorPrefix",
  schema: NetworkOperatorPrefixSchema,
  url: "/prefixes",
  commons: mainStore.commons
});
